<template>
  <base-layout>
    <ul class="nav navbar-nav navbar-left" slot="toolbar_buttons">
    </ul>

    <!-- slot main -->

    <div class="col-xs-12 main" slot="main">
      <!-- components -->
      <div class="row ls-charts">
        <h1>Active Campaigns</h1>
        <div v-for="destination in campaigns" :key="destination.owner" class="col-xs-12 box panel">
          <div class="panel-header">
            <h2>{{ destination.owner }}</h2>
          </div>
          <div v-if="isSalesAgentView" class="panel-body">
            <table class="table table-striped table-hover table-bordered campaigns-table">
              <thead>
                <th colspan="2">Campaigns</th>
              </thead>
              <tbody>
                <tr v-for="campaign in destination.campaigns">
                  <td>{{ campaign.name }}</td>
                  <td>
                    <router-link  v-if="campaign.campaign_type == 'bookable-appointment'" class="btn btn-primary btn-sm" :to="'/campaign-form/' + campaign.id"><i class="fa fa-search"></i> Find Appointment</router-link>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else v-for="campaign in destination.campaigns" class="box panel">
            <div class="panel-body">
              <h4>
                <span class="label" v-if="campaign.is_test">TEST </span>
                <b>
                  <span v-if="campaign.campaign_type == 'google'"><i class="fa fa-google"></i> - </span>
                  <span v-if="campaign.campaign_type == 'facebook'"><i class="fa fa-facebook"></i> - </span>
                  {{campaign.name}}
                </b>
              </h4>
              <p>{{ campaign.description }}</p>
              <h5 v-if="campaign.campaign_type == 'bookable-appointment'">Actions</h5>
              <p>
                <router-link  v-if="campaign.campaign_type == 'bookable-appointment'" class="btn btn-primary" :to="'/campaign-form/' + campaign.id">Find Appointment</router-link>
              </p>
              <p>
              <a v-if="campaign.zipcodes_report_url" :href="campaign.zipcodes_report_url" target="_blank"><i class="fa fa-map"></i> Download Zipcodes Report</a>
              </p>
                <h5>Endpoints</h5>
                <table class="table table-condensed">
                  <tr v-if="campaign.ping_url"><th>Ping</th><td><code>{{ campaign.ping_url }}</code></td></tr>
                  <tr v-if="campaign.test_ping_url"><th>Test Ping</th><td><code>{{ campaign.test_ping_url }}</code></td></tr>
                  <tr v-if="campaign.inbox_url"><th>Production</th><td><code>{{ campaign.inbox_url }}</code></td></tr>
                  <tr v-if="campaign.google_key"><th>Google Key</th><td><code>{{ campaign.google_key }}</code></td></tr>
                  <tr v-if="campaign.test_inbox_url"><th>Test</th><td><code>{{ campaign.test_inbox_url }}</code></td></tr>
                  <tr v-if="campaign.campaign_type == 'facebook'"><td colspan="2">This campaign does not use API endpoints</td></tr>
                </table>

                <h5>Fields</h5>
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th>API Name</th>
                      <th>Required</th>
                      <th>Field Type</th>
                      <th>Format</th>
                      <th>Notes</th><th>Field Definition</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="f in campaign.fields.filter(f => f.field_type !== 'read_only')">
                      <template v-if="f.field">
                        <th class="align-middle">{{ f.alias }}</th>
                        <td class="align-middle"><yes-no :ok="f.is_required"></yes-no></td>
                        <td class="align-middle">{{ f.api_doc.field_type }}</td>
                        <td class="align-middle">{{f .api_doc.field_format }}</td>
                        <td><pre v-if="f.notes">{{ f.notes }}</pre></td>
                        <td><a v-if="f.field_definition_url" :href="f.field_definition_url"><i class="fa fa-file"></i> Download</a></td>
                      </template>
                    </tr>
                  </tbody>
                </table>
                <div v-if="campaign.capacity && (campaign.capacity.hourly || campaign.capacity.daily || campaign.capacity.weekly || campaign.capacity.monthly)" class="col-xs-12">
                  <h5>Capacity</h5>
                  <ul>
                    <li v-if="campaign.capacity.hourly">Hourly: <b>{{ campaign.capacity.hourly }}</b> leads</li>
                    <li v-if="campaign.capacity.daily">Daily: <b>{{ campaign.capacity.daily }}</b> leads</li>
                    <li v-if="campaign.capacity.weekly">Weekly: <b>{{ campaign.capacity.weekly }}</b> leads</li>
                    <li v-if="campaign.capacity.monthly">Monthly: <b>{{ campaign.capacity.monthly }}</b> leads</li>
                  </ul>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div slot="modals">

    </div>
  </base-layout>
</template>

<script>
  /**
  * https://github.com/jbaysolutions/vue-grid-layout
  */
 import Vue from 'vue';

 import YesNo from 'components/elements/YesNo';
 import {BaseLayout} from 'components/layouts/';

 // Load the full build.
 var _ = require('lodash');

 export default {
   components: {
     BaseLayout,
     YesNo
   },
   data () {
     return {
       /* These are part of colums */
       campaigns: [],
       isSalesAgentView: false
     };
   },
    created () {
      this.isSalesAgentView = this.$store.state.user.role == 'sales_agent';
      this.getCampaigns();
    },
   methods: {
     getCampaigns() {
       var self = this;
         API.providerCampaigns.getList()
            .then(function (res) {
                self.campaigns = [];

                var customers = {};

                res.data.forEach(function (item) {
                    if (!(item.owner_name in customers)) {
                        customers[item.owner_name] = {
                            owner: item.owner_name,
                            collapsed: false,
                            campaigns: []
                        };
                    }
                  customers[item.owner_name]['campaigns'].push(item);
                });

                // All campaigns grouped by customer
                self.campaigns = _.sortBy(_.values(customers), (customer) => customer.owner);
            });
     }
   }
 }
</script>

<style lang="scss" scoped>
  .panel {
    .panel-header {
      h2 {
        line-height: 2rem;
        margin-bottom: .5rem;
        font-weight: 700;
      }
    }

    .panel-body {
      h5 {
        font-weight: 600;
        font-size: 110%;
        line-height: 2rem;
      }

      padding: 1rem!important;

      .campaigns-table {

        thead {
          th {
            padding: 6px 5px;
            line-height: 2rem;
          }
        }

        tbody {
          tr {
            td {
              line-height: 1.8rem;
            }
          }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// Campaigns.vue?e7cab0ea